import { render, staticRenderFns } from "./UsersProjectComponent.vue?vue&type=template&id=386d7d9f"
import script from "./UsersProjectComponent.js?vue&type=script&lang=js&external"
export * from "./UsersProjectComponent.js?vue&type=script&lang=js&external"
import style0 from "./UsersProjectComponent.vue?vue&type=style&index=0&id=386d7d9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports